import { IHttpClient } from '@micro-frontend-react/employee-experience/lib/IHttpClient';
import { put, getContext, all, takeLatest, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { ContentsActionType, IRequestViewContentsAction } from './Contents.action-types';
import { receiveViewContents } from './Contents.actions';

export function* fetchContents(action: IRequestViewContentsAction): SagaIterator {
  const { applicationId, viewId } = action;

  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    const { data } = yield call([httpClient, httpClient.request], {
      url: `${__API_BASE_URL__}/applications/${applicationId}/views/${viewId}/contents`,
      resource: __API_RESOURCE__,
    });

    yield put(receiveViewContents(viewId, data));
  } catch {}
}

export function* contentsSagas(): SagaIterator {
  yield all([takeLatest(ContentsActionType.REQUEST_VIEW_CONTENTS, fetchContents)]);
}
